import { render, staticRenderFns } from "./AffiliatesPage.vue?vue&type=template&id=6c9b5086&scoped=true&"
import script from "./AffiliatesPage.vue?vue&type=script&lang=js&"
export * from "./AffiliatesPage.vue?vue&type=script&lang=js&"
import style0 from "./AffiliatesPage.vue?vue&type=style&index=0&id=6c9b5086&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9b5086",
  null
  
)

export default component.exports